import artPalette from 'images/icons/art-palette.svg'
import compass from 'images/icons/compass.svg'
import rocket from 'images/icons/rocket.svg'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'

import './PathwayLabel.scss'

export const PathwayLabel = ({
  category = 'general',
  className = '',
  description = '',
  title = '',
  t,
}) => {
  const categoryIcons = {
    explore: compass,
    design: artPalette,
    invent: rocket,
  }
  const labelIcon = categoryIcons[category]
  const labelTitle =
    category === 'general'
      ? title
      : t(`pathway.project-label.${category}.title`, { defaultValue: '' })
  const labelDescription =
    category === 'general'
      ? description
      : t(`pathway.project-label.${category}.description`, { defaultValue: '' })

  return (
    <div className={className}>
      {labelTitle && (
        <div className="sl-section c-projects-pathway-label">
          <div className="c-projects-pathway-label__title-section">
            {labelIcon && (
              <img
                className="c-projects-pathway-label__icon"
                src={labelIcon}
                alt=""
              />
            )}
            <h2 className="c-projects-pathway-label__title">{labelTitle}</h2>
            {labelTitle && labelDescription && (
              <h2 className="c-projects-pathway-label__title-join">-</h2>
            )}
          </div>
          <h3 className="c-projects-pathway-label__description">
            {labelDescription}
          </h3>
        </div>
      )}
    </div>
  )
}

PathwayLabel.propTypes = {
  category: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string,
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default withNamespaces('translations')(PathwayLabel)
